import React, { type ComponentProps } from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@garnish/constants';

import { useResponsive } from '../../../../hooks';
import { LabelText } from '../../../Text';

// ─────────────────────────────────────────────────────────────────────────────

export const IngredientListItemNoticeLabel = (props: Props) => {
  const { children, style, ...restProps } = props;

  const { match } = useResponsive();

  const containerStyles = [
    styles.container,
    match([styles.containerXS, styles.containerSM]),
  ];

  return (
    // NOTE: An outer container allows to position the notice label absolutely without affecting the layout of the parent.
    <View>
      <View style={containerStyles}>
        <LabelText
          sizeMatch={['10', '12']}
          style={[styles.text, style]}
          {...restProps}
        >
          {children}
        </LabelText>
      </View>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: theme.colors.PEACH,
    marginTop: theme.spacing['2'],
    marginHorizontal: 'auto',
  },
  containerXS: {
    borderRadius: theme.radius.small,
    paddingVertical: 2,
    paddingHorizontal: theme.spacing['1'],
  },
  containerSM: {
    borderRadius: theme.radius.medium,
    paddingVertical: theme.spacing['1'],
    paddingHorizontal: theme.spacing['2'],
  },
  text: {
    textAlign: 'center',
    color: theme.colors.CAUTION,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = ComponentProps<typeof LabelText>;
